import { AutogenModelFreightMatchingProfileLookup, AutogenRowFreightMatchingProfileLookup } from "./autogen/AutogenModelFreightMatchingProfileLookup";

export class ModelFreightMatchingProfileLookup extends AutogenModelFreightMatchingProfileLookup<RowFreightMatchingProfileLookup> {
	constructor() {
		super(RowFreightMatchingProfileLookup);
	}
}

export class RowFreightMatchingProfileLookup extends AutogenRowFreightMatchingProfileLookup {
}